import api from './api-config';
import { CasesDTO } from '../models/Cases';

interface CaseCriteria {
  'id.greaterThan'?: number;
  'id.lessThan'?: number;
  'id.greaterThanOrEqual'?: number;
  'id.lessThanOrEqual'?: number;
  'id.equals'?: number;
  'id.notEquals'?: number;
  'id.specified'?: boolean;
  'id.in'?: number[];
  'id.notIn'?: number[];
  'createdAt.greaterThan'?: string;
  'createdAt.lessThan'?: string;
  'createdAt.greaterThanOrEqual'?: string;
  'createdAt.lessThanOrEqual'?: string;
  'createdAt.equals'?: string;
  'createdAt.notEquals'?: string;
  'createdAt.specified'?: boolean;
  'createdAt.in'?: string[];
  'createdAt.notIn'?: string[];
  'caseStatus.equals'?: 'DRAFT' | 'OPEN' | 'IN_PROGRESS' | 'CLOSED';
  'caseStatus.notEquals'?: 'DRAFT' | 'OPEN' | 'IN_PROGRESS' | 'CLOSED';
  'caseStatus.specified'?: boolean;
  'caseStatus.in'?: ('DRAFT' | 'OPEN' | 'IN_PROGRESS' | 'CLOSED')[];
  'caseStatus.notIn'?: ('DRAFT' | 'OPEN' | 'IN_PROGRESS' | 'CLOSED')[];
  'openingDate.greaterThan'?: string;
  'openingDate.lessThan'?: string;
  'openingDate.greaterThanOrEqual'?: string;
  'openingDate.lessThanOrEqual'?: string;
  'openingDate.equals'?: string;
  'openingDate.notEquals'?: string;
  'openingDate.specified'?: boolean;
  'openingDate.in'?: string[];
  'openingDate.notIn'?: string[];
  'confirmationDate.greaterThan'?: string;
  'confirmationDate.lessThan'?: string;
  'confirmationDate.greaterThanOrEqual'?: string;
  'confirmationDate.lessThanOrEqual'?: string;
  'confirmationDate.equals'?: string;
  'confirmationDate.notEquals'?: string;
  'confirmationDate.specified'?: boolean;
  'confirmationDate.in'?: string[];
  'confirmationDate.notIn'?: string[];
  'closingDate.greaterThan'?: string;
  'closingDate.lessThan'?: string;
  'closingDate.greaterThanOrEqual'?: string;
  'closingDate.lessThanOrEqual'?: string;
  'closingDate.equals'?: string;
  'closingDate.notEquals'?: string;
  'closingDate.specified'?: boolean;
  'closingDate.in'?: string[];
  'closingDate.notIn'?: string[];
  'caseDocumentsId.greaterThan'?: number;
  'caseDocumentsId.lessThan'?: number;
  'caseDocumentsId.greaterThanOrEqual'?: number;
  'caseDocumentsId.lessThanOrEqual'?: number;
  'caseDocumentsId.equals'?: number;
  'caseDocumentsId.notEquals'?: number;
  'caseDocumentsId.specified'?: boolean;
  'caseDocumentsId.in'?: number[];
  'caseDocumentsId.notIn'?: number[];
  'caseNotesId.greaterThan'?: number;
  'caseNotesId.lessThan'?: number;
  'caseNotesId.greaterThanOrEqual'?: number;
  'caseNotesId.lessThanOrEqual'?: number;
  'caseNotesId.equals'?: number;
  'caseNotesId.notEquals'?: number;
  'caseNotesId.specified'?: boolean;
  'caseNotesId.in'?: number[];
  'caseNotesId.notIn'?: number[];
  'caseHistoryId.greaterThan'?: number;
  'caseHistoryId.lessThan'?: number;
  'caseHistoryId.greaterThanOrEqual'?: number;
  'caseHistoryId.lessThanOrEqual'?: number;
  'caseHistoryId.equals'?: number;
  'caseHistoryId.notEquals'?: number;
  'caseHistoryId.specified'?: boolean;
  'caseHistoryId.in'?: number[];
  'caseHistoryId.notIn'?: number[];
  'caseClinicalNotesId.greaterThan'?: number;
  'caseClinicalNotesId.lessThan'?: number;
  'caseClinicalNotesId.greaterThanOrEqual'?: number;
  'caseClinicalNotesId.lessThanOrEqual'?: number;
  'caseClinicalNotesId.equals'?: number;
  'caseClinicalNotesId.notEquals'?: number;
  'caseClinicalNotesId.specified'?: boolean;
  'caseClinicalNotesId.in'?: number[];
  'caseClinicalNotesId.notIn'?: number[];
  'clinicalDocumentsId.greaterThan'?: number;
  'clinicalDocumentsId.lessThan'?: number;
  'clinicalDocumentsId.greaterThanOrEqual'?: number;
  'clinicalDocumentsId.lessThanOrEqual'?: number;
  'clinicalDocumentsId.equals'?: number;
  'clinicalDocumentsId.notEquals'?: number;
  'clinicalDocumentsId.specified'?: boolean;
  'clinicalDocumentsId.in'?: number[];
  'clinicalDocumentsId.notIn'?: number[];
  'treatmentPlansId.greaterThan'?: number;
  'treatmentPlansId.lessThan'?: number;
  'treatmentPlansId.greaterThanOrEqual'?: number;
  'treatmentPlansId.lessThanOrEqual'?: number;
  'treatmentPlansId.equals'?: number;
  'treatmentPlansId.notEquals'?: number;
  'treatmentPlansId.specified'?: boolean;
  'treatmentPlansId.in'?: number[];
  'treatmentPlansId.notIn'?: number[];
  'notificationsId.greaterThan'?: number;
  'notificationsId.lessThan'?: number;
  'notificationsId.greaterThanOrEqual'?: number;
  'notificationsId.lessThanOrEqual'?: number;
  'notificationsId.equals'?: number;
  'notificationsId.notEquals'?: number;
  'notificationsId.specified'?: boolean;
  'notificationsId.in'?: number[];
  'notificationsId.notIn'?: number[];
  'createdById.greaterThan'?: number;
  'createdById.lessThan'?: number;
  'createdById.greaterThanOrEqual'?: number;
  'createdById.lessThanOrEqual'?: number;
  'createdById.equals'?: number;
  'createdById.notEquals'?: number;
  'createdById.specified'?: boolean;
  'createdById.in'?: number[];
  'createdById.notIn'?: number[];
  'closedById.greaterThan'?: number;
  'closedById.lessThan'?: number;
  'closedById.greaterThanOrEqual'?: number;
  'closedById.lessThanOrEqual'?: number;
  'closedById.equals'?: number;
  'closedById.notEquals'?: number;
  'closedById.specified'?: boolean;
  'closedById.in'?: number[];
  'closedById.notIn'?: number[];
  'privacyUploadById.greaterThan'?: number;
  'privacyUploadById.lessThan'?: number;
  'privacyUploadById.greaterThanOrEqual'?: number;
  'privacyUploadById.lessThanOrEqual'?: number;
  'privacyUploadById.equals'?: number;
  'privacyUploadById.notEquals'?: number;
  'privacyUploadById.specified'?: boolean;
  'privacyUploadById.in'?: number[];
  'privacyUploadById.notIn'?: number[];
  'doctorsId.greaterThan'?: number;
  'doctorsId.lessThan'?: number;
  'doctorsId.greaterThanOrEqual'?: number;
  'doctorsId.lessThanOrEqual'?: number;
  'doctorsId.equals'?: number;
  'doctorsId.notEquals'?: number;
  'doctorsId.specified'?: boolean;
  'doctorsId.in'?: number[];
  'doctorsId.notIn'?: number[];
  'patientId.greaterThan'?: number;
  'patientId.lessThan'?: number;
  'patientId.greaterThanOrEqual'?: number;
  'patientId.lessThanOrEqual'?: number;
  'patientId.equals'?: number;
  'patientId.notEquals'?: number;
  'patientId.specified'?: boolean;
  'patientId.in'?: number[];
  'patientId.notIn'?: number[];
  distinct?: boolean;
  page?: number;
  size?: number;
  sort?: string[];
}

export const casesService = {
  getAllCases: async (params?: CaseCriteria) => {
    const response = await api.get<CasesDTO[]>('/cases', {
      params: {
        ...params,
        sort: params?.sort?.join(',')
      }
    });
    return response.data;
  },

  getCaseById: async (id: number) => {
    const response = await api.get<CasesDTO>(`/cases/${id}`);
    return response.data;
  },

  createCase: async (caseData: CasesDTO) => {
    const response = await api.post<CasesDTO>('/cases', caseData);
    return response.data;
  },

  updateCase: async (id: number, caseData: CasesDTO) => {
    const response = await api.put<CasesDTO>(`/cases/${id}`, caseData);
    return response.data;
  },

  deleteCase: async (id: number) => {
    await api.delete(`/cases/${id}`);
  },

  partialUpdateCase: async (id: number, caseData: Partial<CasesDTO>) => {
    const response = await api.patch<CasesDTO>(`/cases/${id}`, caseData);
    return response.data;
  },

  countCases: async (params?: CaseCriteria) => {
    const response = await api.get<number>('/cases/count', { params });
    return response.data;
  },

  changeStatus: async (id: number, status: 'DRAFT' | 'OPEN' | 'IN_PROGRESS' | 'CLOSED') => {
    const response = await api.post<CasesDTO>(`/cases/${id}/changeStatus`, null, {
      params: { status }
    });
    return response.data;
  },

  exportCases: async (filters:CaseCriteria): Promise<Blob> => {
    const response = await api.get('/cases/export', {
      params: {
        ...filters,
        sort: filters?.sort?.join(',')
      },
      responseType: 'blob'
    });
    return response.data;
  }
  
};